// extracted by mini-css-extract-plugin
export default {"container":"Currency__container___Eh3cs"};